<p-toast></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

@if (formLoading) {
  <div>
    <mat-spinner></mat-spinner>
  </div>
}

@if (hideTitle) {
  <h2>{{formTitle}}</h2>
}

<form *ngIf="formReady" [formGroup]="form1" class="d-flex">
  @if (guestProfile) {
    <h2>Guest Profile</h2>
  }
  @if ((parentScreen && parentScreen=='msgcampaign' && guestProfile) || !parentScreen) {
    <div class="d-flex flex-wrap align-items-center"
      >
      @if (showStartDate) {
        <span class="p-float-label my-2 me-2 d-block">
          <p-calendar inputId="formStartDate" formControlName="formStartDate" [style]="{'width':'200px'}"
            appendTo="body" (onSelect)="onChange('fromDate')">
          </p-calendar>
          <label for="formStartDate">@if (startDateLabel) {
            <span>{{startDateLabel}}</span>
            } @if (!startDateLabel) {
            <span
            >From</span>
          }</label>
        </span>
      }
      @if (showEndDate) {
        <span class="p-float-label my-2 me-2 d-block">
          <p-calendar #checkOutDateCal inputId="formEndDate" formControlName="formEndDate" [style]="{'width':'200px'}"
            appendTo="body" (onSelect)="onChange()" [minDate]="minToDate" [defaultDate]="minToDate">
          </p-calendar>
          <label for="formEndDate">@if (endDateLabel) {
            <span>{{endDateLabel}}</span>
            } @if (!endDateLabel) {
            <span
            >To</span>
          }</label>
        </span>
      }
      @if (showSaleDateStart) {
        <span class="p-float-label my-2 me-2 d-block">
          <p-calendar formControlName="formSaleDateStart" inputId="formSaleDateStart" [style]="{'width':'200px'}"
            appendTo="body" (onSelect)="onChange('saleDateStart')">
          </p-calendar>
          <label for="formSaleDateStart">@if (saleDateStartLabel) {
            <span>{{saleDateStartLabel}}</span>
          } @if (!saleDateStartLabel) {
            <span>Sale Date Start</span>
          }</label>
        </span>
      }
      @if (showSaleDateEnd) {
        <span class="p-float-label my-2 me-2 d-block">
          <p-calendar #saleDateEndCal formControlName="formSaleDateEnd" inputId="formSaleDateEnd" [style]="{'width':'200px'}"
            appendTo="body" [minDate]="minSaleDateEnd">
          </p-calendar>
          <label for="formSaleDateEnd">@if (saleDateEndLabel) {
            <span>{{saleDateEndLabel}}</span>
          } @if (!saleDateEndLabel) {
            <span>Sale Date End</span>
          }</label>
        </span>
      }
      @if (showCheckInDateStart) {
        <span class="p-float-label my-2 me-2 d-block">
          <p-calendar inputId="CheckInStart" formControlName="formCheckInDateStart" [style]="{'width':'200px'}"
            appendTo="body">
          </p-calendar>
          <label for="CheckInStart">CheckIn Date Start</label>
        </span>
      }
      @if (showCheckInDateEnd) {
        <span class="p-float-label my-2 me-2 d-block">
          <p-calendar inputId="checkInEnd" formControlName="formCheckInDateEnd" [style]="{'width':'200px'}"
            appendTo="body">
          </p-calendar>
          <label for="checkInEnd">CheckIn Date End</label>
        </span>
      }
      @if (showCheckOutDateStart) {
        <span class="p-float-label my-2 me-2 d-block">
          <p-calendar inputId="CheckOutStart" formControlName="formCheckOutDateStart" [style]="{'width':'200px'}"
            appendTo="body">
          </p-calendar>
          <label for="CheckOutStart">CheckOut Date Start</label>
        </span>
      }
      @if (showCheckOutDateEnd) {
        <span class="p-float-label my-2 me-2 d-block">
          <p-calendar inputId="checkOutEnd" formControlName="formCheckOutDateEnd" [style]="{'width':'200px'}"
            appendTo="body">
          </p-calendar>
          <label for="checkOutEnd">CheckOut Date End</label>
        </span>
      }
      @if (showHoldDateStart) {
        <span class="p-float-label my-2 me-2 d-block">
          <p-calendar inputId="holdStart" formControlName="formHoldDateStart" [style]="{'width':'200px'}"
            appendTo="body">
          </p-calendar>
          <label for="holdStart">Hold Date Start</label>
        </span>
      }
      @if (showHoldDateEnd) {
        <span class="p-float-label my-2 me-2 d-block">
          <p-calendar inputId="holdEnd" formControlName="formHoldDateEnd" [style]="{'width':'200px'}" appendTo="body">
          </p-calendar>
          <label for="holdEnd">Hold Date End</label>
        </span>
      }
      @if (showHoldExpiredDateStart) {
        <span class="p-float-label my-2 me-2 d-block">
          <p-calendar inputId="holdExpiredDateStart" formControlName="formHoldExpiredDateStart"
            [style]="{'width':'200px'}" appendTo="body">
          </p-calendar>
          <label for="holdExpiredDateStart">Hold Expired Date Start</label>
        </span>
      }
      @if (showHoldExpiredDateEnd) {
        <span class="p-float-label my-2 me-2 d-block">
          <p-calendar inputId="holdExpiredDateEnd" formControlName="formHoldExpiredDateEnd"
            [style]="{'width':'200px'}" appendTo="body">
          </p-calendar>
          <label for="holdExpiredDateEnd">Hold Expired Date End</label>
        </span>
      }
      @if (showCancelDateStart) {
        <span class="p-float-label my-2 me-2 d-block">
          <p-calendar inputId="cancelDateStart" formControlName="formCancelDateStart" [style]="{'width':'200px'}"
            appendTo="body">
          </p-calendar>
          <label for="cancelDateStart">Cancel Date Start</label>
        </span>
      }
      @if (showCancelDateEnd) {
        <span class="p-float-label my-2 me-2 d-block">
          <p-calendar inputId="cancelDateEnd" formControlName="formCancelDateEnd" [style]="{'width':'200px'}"
            appendTo="body">
          </p-calendar>
          <label for="cancelDateEnd">Cancel Date End</label>
        </span>
      }
      @if (showFilterDateStart) {
        <span class="p-float-label my-2 me-2 d-block">
          <p-calendar inputId="filterDateStart" (onSelect)="onChange('filterDateStart')" formControlName="formFilterDateStart" [style]="{'width':'200px'}"
            appendTo="body">
          </p-calendar>
          <label for="filterDateStart">@if (filterDateStartLabel) {
            <span>{{filterDateStartLabel}}</span>
          } @if (!filterDateStartLabel) {
            <span>Filter Date Start</span>
          }</label>
        </span>
      }
      @if (showFilterDateEnd) {
        <span class="p-float-label my-2 me-2 d-block">
          <p-calendar #filterDateEndCal inputId="filterDateEnd" formControlName="formFilterDateEnd" [style]="{'width':'200px'}"
            appendTo="body" [minDate]="minFilterEndDate">
          </p-calendar>
          <label for="filterDateEnd">@if (filterDateEndLabel) {
            <span>{{filterDateEndLabel}}</span>
          } @if (!filterDateEndLabel) {
            <span>Filter Date End</span>
          }</label>
        </span>
      }
      @if (showFutureGuestDate) {
        <span class="p-float-label my-2 me-2 d-block">
          <p-calendar inputId="futureGuestDate" formControlName="formFutureGuestDate" [style]="{'width':'200px'}"
            appendTo="body">
          </p-calendar>
          <label for="futureGuestDate">Future Guest Date</label>
        </span>
      }
      @if (showLocations) {
        <span class="p-float-label my-2 me-2 d-block">
          <p-multiSelect autoWidth="false" [ngStyle]="{'minWidth':'175px'}" [scrollHeight]="'50vh'"
            [options]="locations" formControlName="formLocationIds" id="formLocationIds"
            defaultLabel="Select Location" optionValue="locationId" (onChange)="onChange()" optionLabel="name"
            display="chip" appendTo="body">
          </p-multiSelect>
          <label for="formLocationIds">Select Locations</label>
        </span>
      }
      @if (showDevelopments) {
        <span class="p-float-label my-2 me-2 d-block">
          <p-multiSelect autoWidth="false" [ngStyle]="{'minWidth':'175px'}" [scrollHeight]="'50vh'"
            [options]="developments" formControlName="formDevelopmentIds" defaultLabel="Select Resort"
            optionValue="developmentId" id="formLocationIds" optionLabel="addressDevelopmentName" display="chip"
            appendTo="body">
          </p-multiSelect>
          <label for="formLocationIds">Select Resort</label>
        </span>
      }
      @if (showShortTermRentals) {
        <span class="p-float-label my-2 me-2 d-block">
          <p-multiSelect autoWidth="false" [ngStyle]="{'minWidth':'175px'}" [scrollHeight]="'50vh'"
            [options]="shortTermRentals" formControlName="formShortTermRentalIds" defaultLabel="Select Property"
            optionValue="shortTermRentalId" id="formShortTermRentalIds" optionLabel="propertyCode" display="chip"
            appendTo="body">
          </p-multiSelect>
          <label for="formShortTermRentalIds">Select Property</label>
        </span>
      }
      @if (showYieldMaxProperties) {
        <span class="p-float-label my-2 me-2 d-block">
          <p-multiSelect autoWidth="false" [ngStyle]="{'minWidth':'175px'}" [scrollHeight]="'50vh'"
            [options]="yielMaxProperties" formControlName="formYielMaxPropertyIds" defaultLabel="Select Property"
            optionValue="propertyId" id="formYielMaxPropertyIds" optionLabel="propertyCode" display="chip"
            appendTo="body" (onChange)="onChange()">
          </p-multiSelect>
          <label for="formYielMaxPropertyIds">Select Property</label>
        </span>
      }
      @if (showYieldMaxDevelopments) {
        <span class="p-float-label my-2 me-2 d-block">
          <p-multiSelect autoWidth="false" [ngStyle]="{'minWidth':'175px'}" [scrollHeight]="'50vh'"
            [options]="yielMaxDevelopments" formControlName="formYielMaxDevelopmentIds"
            defaultLabel="Select Developments" optionValue="value" id="formYielMaxDevelopmentIds" optionLabel="label"
            display="chip" appendTo="body">
          </p-multiSelect>
          <label for="formYielMaxDevelopmentIds">Select Developments</label>
        </span>
      }
      @if (showViewTypes) {
        <span class="p-float-label my-2 me-2 d-block">
          <p-multiSelect autoWidth="false" [ngStyle]="{'minWidth':'175px'}" [scrollHeight]="'50vh'"
            [options]="viewTypes" formControlName="formViews" defaultLabel="Select View Type" optionValue="value"
            id="formViews" optionLabel="name" display="chip" appendTo="body">
          </p-multiSelect>
          <label for="formViews">Select View Type</label>
        </span>
      }
      @if (showBedrooms) {
        <span class="p-float-label my-2 me-2 d-block">
          <p-multiSelect autoWidth="false" [ngStyle]="{'minWidth':'175px'}" [scrollHeight]="'50vh'"
            [options]="bedrooms" formControlName="formBedrooms" id="formBedrooms" defaultLabel="Select Bedrooms"
            optionValue="id" optionLabel="name" display="chip" appendTo="body">
          </p-multiSelect>
          <label for="formBedrooms">Select Bedrooms</label>
        </span>
      }
      @if (showSleeps) {
        <span class="p-float-label my-2 me-2 d-block">
          <p-multiSelect autoWidth="false" [ngStyle]="{'minWidth':'175px'}" [scrollHeight]="'50vh'" [options]="sleeps"
            formControlName="formSleeps" id="formSleeps" defaultLabel="Select Sleeps" optionValue="id"
            optionLabel="name" display="chip" appendTo="body">
          </p-multiSelect>
          <label for="formSleeps">Select Sleeps</label>
        </span>
      }
      @if (showListingTypes) {
        <span class="p-float-label my-2 me-2 d-block">
          <p-multiSelect autoWidth="false" [ngStyle]="{'minWidth':'175px'}" [scrollHeight]="'50vh'" [options]="listingType"
            formControlName="formListingType" id="formListingType" defaultLabel="Listing Type" optionValue="value"
            optionLabel="name" display="chip" appendTo="body">
          </p-multiSelect>
          <label for="formListingType">Listing Type</label>
        </span>
      }
      @if (showRateBuckets) {
        <span class="p-float-label my-2 me-2 d-block">
          <p-multiSelect autoWidth="false" [ngStyle]="{'minWidth':'175px'}" [scrollHeight]="'50vh'"
            [options]="rateBuckets" formControlName="formRateBucketIds" defaultLabel="Select Buckets"
            optionValue="rateBucketId" id="formRateBucketIds" optionLabel="name" display="chip" appendTo="body">
          </p-multiSelect>
          <label for="formRateBucketIds">Select Buckets</label>
        </span>
      }
      @if (showYieldMaxRateBuckets) {
        <span class="p-float-label my-2 me-2 d-block">
          <p-multiSelect autoWidth="false" [ngStyle]="{'minWidth':'175px'}" [scrollHeight]="'50vh'"
            [options]="yielMaxRateBuckets" formControlName="formYielMaxRateBucketIds" defaultLabel="Select Buckets"
            optionValue="rateBucketId" id="formYielMaxRateBucketIds" optionLabel="name" display="chip" appendTo="body"
            (onChange)="onChange()">
          </p-multiSelect>
          <label for="formYielMaxRateBucketIds">Select Buckets</label>
        </span>
      }
      @if (showSeasons) {
        <span class="p-float-label my-2 me-2 d-block">
          <p-multiSelect autoWidth="false" [ngStyle]="{'minWidth':'175px'}" [scrollHeight]="'50vh'"
            [options]="seasons" formControlName="formSeasons" id="formSeasons" defaultLabel="Select Season"
            optionValue="id" optionLabel="name" display="chip" appendTo="body" (onChange)="onChange()">
          </p-multiSelect>
          <label for="formSeasons">Select Season</label>
        </span>
      }
      @if (showPropertyRanks) {
        <span class="p-float-label my-2 me-2 d-block">
          <p-multiSelect autoWidth="false" [ngStyle]="{'minWidth':'175px'}" [scrollHeight]="'50vh'"
            [options]="propertyRanks" formControlName="formPropertyRank" id="formPropertyRank"
            defaultLabel="Property Class" optionValue="value" optionLabel="name" display="chip" appendTo="body"
            (onChange)="onChange()">
          </p-multiSelect>
          <label for="formPropertyRank">Property Class</label>
        </span>
      }
      @if (showNumNts) {
        <span class="p-float-label my-2 me-2 d-block">
          <p-multiSelect autoWidth="false" [ngStyle]="{'minWidth':'175px'}" [scrollHeight]="'50vh'" [options]="numNts"
            formControlName="formNumNts" id="formNumNts" defaultLabel="Select LOS" optionValue="id" optionLabel="name"
            display="chip" appendTo="body" (onChange)="onChange()">
          </p-multiSelect>
          <label for="formNumNts">Select LOS</label>
        </span>
      }
      @if (showReferralSources) {
        <span class="p-float-label my-2 me-2 d-block">
          <p-multiSelect autoWidth="false" [ngStyle]="{'minWidth':'175px'}" [scrollHeight]="'50vh'"
            [options]="referralSources" formControlName="formReferralSources" id="formReferralSources"
            defaultLabel="Select Channel" optionValue="value" optionLabel="name" display="chip" appendTo="body"
            (onChange)="onChange()">
          </p-multiSelect>
          <label for="formReferralSources">Select Channel</label>
        </span>
      }
      @if (showResTypes) {
        <span class="p-float-label my-2 me-2 d-block">
          <p-multiSelect autoWidth="false" [ngStyle]="{'minWidth':'175px'}" [scrollHeight]="'50vh'"
            [options]="resTypes" formControlName="formResTypes" id="formResTypes" defaultLabel="Reservation Type"
            optionValue="value" optionLabel="name" display="chip" appendTo="body" (onChange)="onChange()">
          </p-multiSelect>
          <label for="formResTypes">Reservation Type</label>
        </span>
      }
      @if (showReservationStatus) {
        <span class="p-float-label my-2 me-2 d-block">
          <p-multiSelect autoWidth="false" [ngStyle]="{'minWidth':'175px'}" [scrollHeight]="'50vh'"
            [options]="constantService.reservationStatuses" formControlName="formReservationStatus"
            defaultLabel="Select Reservation Status" id="formReservationStatus" optionValue="value" optionLabel="label"
          display="chip" appendTo="body"></p-multiSelect>
          <label for="formReservationStatus">Select Reservation Status</label>
        </span>
      }
      @if (showReportType) {
        <span class="p-float-label my-2 me-2 d-block">
          <p-dropdown [options]="constantService.resMasterReportType" formControlName="formResMasterReportType"
            optionLabel="label" optionValue="value" [showClear]="true" appendTo="body"
            [style]="{'minWidth':'175px'}" placeholder="Select Report Type">
          </p-dropdown>
          <label for="formResMasterReportType">Select Report Type</label>
        </span>
      }
      <!-- <span *ngIf="showResMasReportName" class="p-float-label my-2 me-2 d-block">
      <p-dropdown [options]="constantService.resMasterReportNames" formControlName="formResMasterReportName"
        optionLabel="label" optionValue="value" [showClear]="true" appendTo="body"
        [style]="{'minWidth':'175px'}" placeholder="Select Report">
      </p-dropdown>
      <label for="formResMasterReportName">Select Report</label>
    </span> -->
    @if (showListingStatus) {
      <span class="p-float-label my-2 me-2 d-block">
        <p-multiSelect autoWidth="false" [ngStyle]="{'minWidth':'175px'}" [scrollHeight]="'50vh'"
          [options]="listingStatuses" formControlName="listingStatus" id="listingStatus"
          defaultLabel="Select Property Status" optionValue="value" optionLabel="name" display="chip" appendTo="body">
        </p-multiSelect>
        <label for="listingStatus">Select Property Status</label>
      </span>
    }
    @if (showExcludeFutureGuests) {
      <span class="my-2 me-2 d-flex align-items-center justify-content-center">
        <p-checkbox [formControl]="form1.controls['excludeFutureGuests']" id="excludeFutureGuests"
          defaultLabel="Exclude Future Guests" inputId="excludeFutureGuests" [binary]="true">
        </p-checkbox>
        <label class="ms-2" for="excludeFutureGuests" style="min-width: max-content;">Exclude Future Guests</label>
      </span>
    }
    @if (showExcludeFutureGuests) {
      <span class="my-2 me-2 d-flex align-items-center justify-content-center">
        <p-checkbox [formControl]="form1.controls['includeRegisteredGuest']" id="includeRegisteredGuest"
          inputId="includeRegisteredGuest" [binary]="true">
        </p-checkbox>
        <label class="ms-2" for="includeRegisteredGuest" style="min-width: max-content;">Registered Guests</label>
      </span>
    }
    @if (showExcludeFutureGuests) {
      <span class="my-2 me-2 d-flex align-items-center justify-content-center">
        <p-checkbox [formControl]="form1.controls['includeProspectGuest']" id="includeProspectGuest"
          inputId="includeProspectGuest" [binary]="true">
        </p-checkbox>
        <label class="ms-2" for="includeProspectGuest" style="min-width: max-content;">Prospect Guest</label>
      </span>
    }
    @if (showExcludeUnsubscribers) {
      <span class="my-2 me-2 d-flex align-items-center justify-content-center">
        <p-checkbox [formControl]="form1.controls['excludeUnsubscribers']" id="excludeUnsubscribers"
          defaultLabel="Exclude Unsubscribers" inputId="excludeUnsubscribers" [binary]="true">
        </p-checkbox>
        <label class="ms-2" for="excludeUnsubscribers" style="min-width: max-content;">Exclude Unsubscribers</label>
      </span>
    }
    @if (showExcludeOwnerProfiles) {
      <span class="my-2 me-2 d-flex align-items-center justify-content-center">
        <p-checkbox [formControl]="form1.controls['excludeOwnerProfiles']" id="excludeOwnerProfiles"
          defaultLabel="Exclude Owner Profiles" inputId="excludeOwnerProfiles" [binary]="true">
        </p-checkbox>
        <label class="ms-2" for="excludeOwnerProfiles" style="min-width: max-content;">Exclude Owner
        Profiles</label>
      </span>
    }
    @if (showExcludeFutureGuests) {
      <span style="margin-left: 10px">
        <p-autoComplete [suggestions]="tagSuggestions" [multiple]="true" [forceSelection]="false" [dropdown]="false"
          [style]="{'width':'100%','padding-right':'20px'}" [inputStyle]="{'width':'100%'}" [minLength]="1"
          formControlName="guestProfileTags" unique="true" field="name" placeholder="Tags"
          (onSelect)="onSelect($event,110)" (onUnselect)="onUnselect($event,110)" (onKeyUp)="onKeyUp($event)"
          (completeMethod)="onKeyInput($event)">
        </p-autoComplete>
      </span>
    }
    @if (showReservationId) {
      <span style="margin-left: 10px">
        <label for="reservationId"></label>
        <input formControlName="reservationId" id="reservationId" type="text" placeholder="Reservation Id"
          pInputText />
      </span>
    }
    &nbsp;&nbsp;
    @if (showApplyTagButton) {
      <p-button label="{{applyTagLabel}}" (click)="tagApplyButtonClick()"
      class="my-2 d-block"></p-button>
    }
    &nbsp;&nbsp;
    @if (showRemoveTagButton) {
      <p-button label="{{removeTagLabel}}" (click)="tagRemoveButtonClick()"
      class="my-2 d-block"></p-button>
    }
  </div>
}

@if (ownerLeadProfile) {
  <h2>Owner Lead Profile</h2>
}
@if (ownerLeadProfile) {
  <div class="d-flex flex-wrap align-items-center">
    @if (showOwnerLeadListingStatus) {
      <span class="p-float-label my-2 me-2 d-block">
        <p-multiSelect autoWidth="false" [ngStyle]="{'minWidth':'175px'}" [scrollHeight]="'50vh'"
          [options]="ownerProfileListingStatuses" formControlName="ownerLeadListingStatus"
          id="ownerLeadListingStatus" defaultLabel="Select Listing Status" optionValue="value" optionLabel="name"
          display="chip" appendTo="body">
        </p-multiSelect>
        <label for="ownerLeadListingStatus">Select Listing Status</label>
      </span>
    }
    @if (showSubAdrCity) {
      <span class="p-float-label my-2 me-2 d-block">
        <p-multiSelect autoWidth="false" [ngStyle]="{'minWidth':'175px'}" [scrollHeight]="'50vh'"
          [options]="ownerLeadProfileCityList" formControlName="ownerLeadSubAdrCity" id="ownerLeadSubAdrCity"
          defaultLabel="Select City" optionValue="name" optionLabel="name" display="chip" appendTo="body">
        </p-multiSelect>
        <label for="ownerLeadSubAdrCity">Select Cities</label>
      </span>
    }
    @if (showSubAdrIsland) {
      <span class="p-float-label my-2 me-2 d-block">
        <p-multiSelect autoWidth="false" [ngStyle]="{'minWidth':'175px'}" [scrollHeight]="'50vh'"
          [options]="ownerLeadProfileSubAdrIslandList" formControlName="ownerLeadSubAdrIsland"
          id="ownerLeadSubAdrIsland" defaultLabel="Select Island" optionValue="name" optionLabel="name" display="chip"
          appendTo="body">
        </p-multiSelect>
        <label for="ownerLeadSubAdrIsland">Select Islands</label>
      </span>
    }
    @if (showSubjAdrState) {
      <span class="p-float-label  my-2 d-block">
        <p-multiSelect autoWidth="false" [ngStyle]="{'minWidth':'175px'}" [scrollHeight]="'50vh'"
          [options]="ownerLeadProfileSubjAdrStateList" formControlName="ownerLeadSubjAdrState"
          id="ownerLeadSubjAdrState" defaultLabel="Select State" optionValue="name" optionLabel="name" display="chip"
          appendTo="body">
        </p-multiSelect>
        <label for="ownerLeadSubjAdrState">Select States</label>
      </span>
    }
    <p-autoComplete [suggestions]="tagSuggestions" [multiple]="true" [forceSelection]="false" [dropdown]="false"
      [style]="{'width':'100%','padding-right':'20px'}" [inputStyle]="{'width':'100%'}" [minLength]="1"
      formControlName="ownerLeadProfileTags" unique="true" field="name" placeholder="Tags"
      (onSelect)="onSelect($event,10)" (onUnselect)="onUnselect($event,10)" (onKeyUp)="onKeyUp($event)"
      (completeMethod)="onKeyInput($event)">
    </p-autoComplete>
  </div>
}
@if (ownerProfile) {
  <h2>Owner Profile</h2>
}
@if (ownerProfile) {
  <div class="d-flex flex-wrap align-items-center">
    @if (showOwnerListingStatus) {
      <span class="p-float-label my-2 me-2 d-block">
        <p-multiSelect autoWidth="false" [ngStyle]="{'minWidth':'175px'}" [scrollHeight]="'50vh'"
          [options]="ownerProfileListingStatusList" formControlName="ownerListingStatus" id="ownerListingStatus"
          defaultLabel="Select Listing Status" optionValue="name" optionLabel="name" display="chip" appendTo="body">
        </p-multiSelect>
        <label for="ownerListingStatus">Select Listing Status</label>
      </span>
    }
    <span>&nbsp; AND&nbsp; </span>
    @if (showSubAdrDevelopmentName) {
      <span class="p-float-label  my-3 d-block">
        <p-multiSelect autoWidth="false" [ngStyle]="{'minWidth':'175px'}" [scrollHeight]="'50vh'"
          [options]="ownerProfileDevelopmentList" formControlName="ownerProfileSubjAdrDevelopmentName"
          id="ownerProfileSubjAdrDevelopmentName" defaultLabel="Select Developments" optionValue="name"
          optionLabel="name" display="chip" appendTo="body">
        </p-multiSelect>
        <label for="ownerProfileSubjAdrDevelopmentName">Select Developments</label>
      </span>
    }
    <span>&nbsp; OR&nbsp; </span>
    @if (showSubAdrIsland) {
      <span class="p-float-label my-2 me-2 d-block">
        <p-multiSelect autoWidth="false" [ngStyle]="{'minWidth':'175px'}" [scrollHeight]="'50vh'"
          [options]="ownerProfileSubAdrIslandList" formControlName="ownerProfileSubAdrIsland"
          id="ownerProfileSubAdrIsland" defaultLabel="Select Islands" optionValue="name" optionLabel="name"
          display="chip" appendTo="body">
        </p-multiSelect>
        <label for="ownerProfileSubAdrIsland">Select Islands</label>
      </span>
    }
    <span>&nbsp; OR&nbsp; </span>
    @if (showSubjAdrState) {
      <span class="p-float-label  my-2 d-block">
        <p-multiSelect autoWidth="false" [ngStyle]="{'minWidth':'175px'}" [scrollHeight]="'50vh'"
          [options]="ownerProfileSubjAdrStateList" formControlName="ownerProfileSubjAdrState"
          id="ownerProfileSubjAdrState" defaultLabel="Select State" optionValue="name" optionLabel="name"
          display="chip" appendTo="body">
        </p-multiSelect>
        <label for="ownerProfileSubjAdrState">Select States</label>
      </span>
    }
    <span>&nbsp; OR&nbsp; </span>
    @if (showShortTermRentals) {
      <span class="p-float-label my-2 me-2 d-block">
        <p-multiSelect autoWidth="false" [ngStyle]="{'minWidth':'175px'}" [scrollHeight]="'50vh'"
          [options]="shortTermRentals" formControlName="ownerProfileShortTermRental"
          defaultLabel="Select Property" optionValue="shortTermRentalId" id="ownerProfileShortTermRental"
          optionLabel="propertyCode" display="chip" appendTo="body">
        </p-multiSelect>
        <label for="formShortTermRentalIds">Select Property</label>
      </span>
    }
    <span>&nbsp; OR&nbsp; </span>
    <p-autoComplete [suggestions]="tagSuggestions" [multiple]="true" [forceSelection]="false" [dropdown]="false"
      [style]="{'width':'100%','padding-right':'20px'}" [inputStyle]="{'width':'100%'}" [minLength]="1"
      formControlName="ownerProfileTags" unique="true" field="name" placeholder="Tags"
      (onSelect)="onSelect($event,50)" (onUnselect)="onUnselect($event,50)" (onKeyUp)="onKeyUp($event)"
      (completeMethod)="onKeyInput($event)">
    </p-autoComplete>
  </div>
}


@if (guestMasterProfile) {
  <h2>Guest Master Profile</h2>
}
@if (guestMasterProfile) {
  <div class="d-flex flex-wrap align-items-center">
    @if (showSubAdrDevelopmentName) {
      <span class="p-float-label  my-3 d-block">
        <p-multiSelect autoWidth="false" [ngStyle]="{'minWidth':'175px'}" [scrollHeight]="'50vh'"
          [options]="guestMasterDevelopmentList" formControlName="guestMasterAdrDevelopmentName"
          id="guestMasterAdrDevelopmentName" defaultLabel="Select Developments" optionValue="name" optionLabel="name"
          display="chip" appendTo="body">
        </p-multiSelect>
        <label for="guestMasterAdrDevelopmentName">Select Developments</label>
      </span>
    }
    @if (showSubAdrIsland) {
      <span class="p-float-label my-2 me-2 d-block">
        <p-multiSelect autoWidth="false" [ngStyle]="{'minWidth':'175px'}" [scrollHeight]="'50vh'"
          [options]="guestMasterSubAdrIslandList" formControlName="guestMasterAdrIsland" id="guestMasterAdrIsland"
          defaultLabel="Select Islands" optionValue="name" optionLabel="name" display="chip" appendTo="body">
        </p-multiSelect>
        <label for="guestMasterAdrIsland">Select Islands</label>
      </span>
    }
    @if (showSubjAdrCity) {
      <span class="p-float-label  my-2 d-block">
        <p-multiSelect autoWidth="false" [ngStyle]="{'minWidth':'175px'}" [scrollHeight]="'50vh'"
          [options]="guestMasterSubjAdrCityList" formControlName="guestMasterAdrCity" id="guestMasterAdrCity"
          defaultLabel="Select Cities" optionValue="name" optionLabel="name" display="chip" appendTo="body">
        </p-multiSelect>
        <label for="guestMasterAdrCity">Select Cities</label>
      </span>
    }
    <p-autoComplete [suggestions]="tagSuggestions" [multiple]="true" [forceSelection]="false" [dropdown]="false"
      [style]="{'width':'100%','padding-right':'20px'}" [inputStyle]="{'width':'100%'}" [minLength]="1"
      formControlName="guestMasterProfileTags" unique="true" field="name" placeholder="Tags"
      (onSelect)="onSelect($event,100)" (onUnselect)="onUnselect($event,100)" (onKeyUp)="onKeyUp($event)"
      (completeMethod)="onKeyInput($event)">
    </p-autoComplete>
  </div>
}

@if (propertyLeadProfile) {
  <h2>Property Lead Profile</h2>
}
@if (propertyLeadProfile) {
  <div class="d-flex flex-wrap align-items-center">
    @if (showOwnerListingStatus) {
      <span class="p-float-label my-2 me-2 d-block">
        <p-multiSelect autoWidth="false" [ngStyle]="{'minWidth':'175px'}" [scrollHeight]="'50vh'"
          [options]="ownerProfileListingStatuses" formControlName="propertyLeadListingStatus"
          id="propertyLeadListingStatus" defaultLabel="Select Listing Status" optionValue="value" optionLabel="name"
          display="chip" appendTo="body">
        </p-multiSelect>
        <label for="propertyLeadListingStatus">Select Listing Status</label>
      </span>
    }
    @if (showSubAdrDevelopmentName) {
      <span class="p-float-label  my-3 d-block">
        <p-multiSelect autoWidth="false" [ngStyle]="{'minWidth':'175px'}" [scrollHeight]="'50vh'"
          [options]="propertyLeadProfileDevelopmentList" formControlName="propertyLeadSubjAdrDevelopmentName"
          id="propertyLeadSubjAdrDevelopmentName" defaultLabel="Select Developments" optionValue="name"
          optionLabel="name" display="chip" appendTo="body">
        </p-multiSelect>
        <label for="propertyLeadSubjAdrDevelopmentName">Select Developments</label>
      </span>
    }
    @if (showSubAdrIsland) {
      <span class="p-float-label my-2 me-2 d-block">
        <p-multiSelect autoWidth="false" [ngStyle]="{'minWidth':'175px'}" [scrollHeight]="'50vh'"
          [options]="propertyLeadProfileSubAdrIslandList" formControlName="propertyLeadSubAdrIsland"
          id="propertyLeadSubAdrIsland" defaultLabel="Select Islands" optionValue="name" optionLabel="name"
          display="chip" appendTo="body">
        </p-multiSelect>
        <label for="propertyLeadSubAdrIsland">Select Islands</label>
      </span>
    }
    @if (showSubjAdrState) {
      <span class="p-float-label  my-2 d-block">
        <p-multiSelect autoWidth="false" [ngStyle]="{'minWidth':'175px'}" [scrollHeight]="'50vh'"
          [options]="propertyLeadProfileSubjAdrStateList" formControlName="propertyLeadSubjAdrState"
          id="propertyLeadSubjAdrState" defaultLabel="Select State" optionValue="name" optionLabel="name"
          display="chip" appendTo="body">
        </p-multiSelect>
        <label for="propertyLeadSubjAdrState">Select States</label>
      </span>
    }
    <p-autoComplete [suggestions]="tagSuggestions" [multiple]="true" [forceSelection]="false" [dropdown]="false"
      [style]="{'width':'100%','padding-right':'20px'}" [inputStyle]="{'width':'100%'}" [minLength]="1"
      formControlName="propertyLeadProfileTags" unique="true" field="name" placeholder="Tags"
      (onSelect)="onSelect($event,20)" (onUnselect)="onUnselect($event,20)" (onKeyUp)="onKeyUp($event)"
      (completeMethod)="onKeyInput($event)">
    </p-autoComplete>
  </div>
}


@if (employeeProfile) {
  <h2>Employee Profile</h2>
}
@if (employeeProfile) {
  <div class="d-flex flex-wrap align-items-center">
    @if (showOwnerListingStatus) {
      <span class="p-float-label my-2 me-2 d-block">
        <p-multiSelect autoWidth="false" [ngStyle]="{'minWidth':'175px'}" [scrollHeight]="'50vh'"
          [options]="employeeListingList" formControlName="employeeLeadListingStatus"
          id="employeeLeadListingStatus" defaultLabel="Select Listing Status" optionValue="value" optionLabel="name"
          display="chip" appendTo="body">
        </p-multiSelect>
        <label for="employeeLeadListingStatus">Select Listing Status</label>
      </span>
    }
    @if (showLocations) {
      <span class="p-float-label my-2 me-2 d-block">
        <p-multiSelect autoWidth="false" [ngStyle]="{'minWidth':'175px'}" [scrollHeight]="'50vh'"
          [options]="locations" formControlName="employeeLocationIdList" id="employeeLocationIdList"
          defaultLabel="Select Location" optionValue="locationId" optionLabel="name" display="chip" appendTo="body">
        </p-multiSelect>
        <label for="employeeLocationIdList">Select Locations</label>
      </span>
    }
    @if (showJobLevel) {
      <span class="p-float-label my-2 me-2 d-block">
        <p-multiSelect autoWidth="false" [ngStyle]="{'minWidth':'175px'}" [scrollHeight]="'50vh'"
          [options]="jobLevelList" formControlName="jobLevel" id="jobLevel" defaultLabel="Select JobLevel"
          optionValue="value" optionLabel="name" display="chip" appendTo="body">
        </p-multiSelect>
        <label for="jobLevel">Select JobLevel</label>
      </span>
    }
    @if (showJobCategories) {
      <span class="p-float-label my-2 me-2 d-block">
        <p-multiSelect autoWidth="false" [ngStyle]="{'minWidth':'175px'}" [scrollHeight]="'50vh'"
          [options]="jobCategoryList" formControlName="jobCategories" id="jobCategories"
          defaultLabel="Select JobCategories" optionValue="value" optionLabel="name" display="chip" appendTo="body">
        </p-multiSelect>
        <label for="jobCategories">Select JobCategories</label>
      </span>
    }
  </div>
}


<!-- <h2 *ngIf="realtorProfile">Realtor Profile</h2> -->
@if (realtorProfile) {
  <div class="d-flex flex-wrap align-items-center">
    @if (showOwnerListingStatus) {
      <span class="p-float-label my-2 me-2 d-block">
        <p-multiSelect autoWidth="false" [ngStyle]="{'minWidth':'175px'}" [scrollHeight]="'50vh'"
          [options]="ownerProfileListingStatuses" formControlName="realtorListingStatus" id="realtorListingStatus"
          defaultLabel="Select Listing Status" optionValue="value" optionLabel="name" display="chip" appendTo="body">
        </p-multiSelect>
        <label for="realtorListingStatus">Select Listing Status</label>
      </span>
    }
    @if (showSubAdrIsland) {
      <span class="p-float-label my-2 me-2 d-block">
        <p-multiSelect autoWidth="false" [ngStyle]="{'minWidth':'175px'}" [scrollHeight]="'50vh'"
          [options]="realtorProfileSubAdrIslandList" formControlName="realtorAdrIsland" id="realtorAdrIsland"
          defaultLabel="Select Island" optionValue="name" optionLabel="name" display="chip" appendTo="body">
        </p-multiSelect>
        <label for="realtorAdrIsland">Select Islands</label>
      </span>
    }
    @if (showSubjAdrState) {
      <span class="p-float-label  my-2 d-block">
        <p-multiSelect autoWidth="false" [ngStyle]="{'minWidth':'175px'}" [scrollHeight]="'50vh'"
          [options]="realtorProfileSubjAdrStateList" formControlName="realtorAdrState" id="realtorAdrState"
          defaultLabel="Select State" optionValue="name" optionLabel="name" display="chip" appendTo="body">
        </p-multiSelect>
        <label for="realtorAdrState">Select State</label>
      </span>
    }
    <p-autoComplete [suggestions]="tagSuggestions" [multiple]="true" [forceSelection]="false" [dropdown]="false"
      [style]="{'width':'100%','padding-right':'20px'}" [inputStyle]="{'width':'100%'}" [minLength]="1"
      formControlName="realtorProfileTags" unique="true" field="name" placeholder="Tags"
      (onSelect)="onSelect($event,90)" (onUnselect)="onUnselect($event,90)" (onKeyUp)="onKeyUp($event)"
      (completeMethod)="onKeyInput($event)">
    </p-autoComplete>
    @if (!viewOnly) {
      <button pButton pRipple class="p-button" style="padding: 0.5rem 0.75rem !important;"
      (click)="openTagAddModalDialog()">Tag +</button>
    }
  </div>
}

@if (contacts) {
  <h2>Contacts</h2>
}
@if (contacts) {
  <div class="d-flex flex-wrap align-items-center">
    @if (showSubAdrIsland) {
      <span class="p-float-label my-2 me-2 d-block">
        <p-multiSelect autoWidth="false" [ngStyle]="{'minWidth':'175px'}" [scrollHeight]="'50vh'"
          [options]="contactSubAdrIslandList" formControlName="contactAdrIsland" id="contactAdrIsland"
          defaultLabel="Select State" optionValue="name" optionLabel="name" display="chip" appendTo="body">
        </p-multiSelect>
        <label for="contactAdrIsland">Select Islands</label>
      </span>
    }
    @if (showSubjAdrState) {
      <span class="p-float-label  my-2 d-block">
        <p-multiSelect autoWidth="false" [ngStyle]="{'minWidth':'175px'}" [scrollHeight]="'50vh'"
          [options]="contanctSubjAdrStateList" formControlName="contactAdrState" id="contactAdrState"
          defaultLabel="Select State" optionValue="name" optionLabel="name" display="chip" appendTo="body">
        </p-multiSelect>
        <label for="contactAdrState">Select State</label>
      </span>
    }
    <span style="margin-left: 10px">
      <label for="contactEmail"></label>
      <input formControlName="contactEmail" id="contactEmail" type="text" pInputText placeholder="Email" />
    </span>
    <span style="margin-left: 10px">
      <label for="contactFirstName"></label>
      <input formControlName="contactFirstName" id="contactFirstName" type="text" pInputText
        placeholder="First Name" />
    </span>
    <span style="margin-left: 10px">
      <label for="contactLastName"></label>
      <input formControlName="contactLastName" id="contactLastName" type="text" pInputText
        placeholder="Last Name" />
    </span>
    <span style="margin-left: 10px">
      <label for="contactsTags"></label>
      <p-autoComplete [suggestions]="tagSuggestions" [multiple]="true" [forceSelection]="false" [dropdown]="false"
        [style]="{'width':'100%','padding-right':'20px'}" [inputStyle]="{'width':'100%'}" [minLength]="1"
        formControlName="contactsTags" unique="true" field="name" placeholder="Select Tags" id="contactsTags"
        (onSelect)="onSelect($event,80)" (onUnselect)="onUnselect($event,80)" (onKeyUp)="onKeyUp($event)"
        (completeMethod)="onKeyInput($event)">
      </p-autoComplete>
    </span>
  </div>
}
<div class="d-flex flex-wrap align-items-center search-btn-group">
  @if (showSearchButton) {
    <p-button label="{{searchLabel}}" (click)="searchClick()"
    class="my-2 d-block"></p-button>
  }
  @if (reset) {
    <button pButton pRipple type="button" label="Reset"
    class="p-button-warning p-button-text my-2 d-block" (click)="form1.reset(); onChange();"></button>
  }
</div>
</form>

<form *ngIf="formReady" [formGroup]="form2" class="d-flex flex-wrap align-items-center">

  @if (showSaleYear) {
    <span class="my-2 d-block">
      <label for="saleYear">Year</label>
      <p-calendar inputId="saleYear" formControlName="formSaleYear" [style]="{'width':'125px'}" appendTo="body"
        view="year" dateFormat="yy">
      </p-calendar>
    </span>
  }

  @if (showSearchButtonForm2) {
    <p-button label="{{searchLabel}}" (click)="searchClickForForm2()"
    class="my-2 d-block"></p-button>
  }


</form>